import { SET_AUTH, SET_PROFILE, LOG_OUT, SET_PERMISSIONS } from './types';

const initialState = {
    isAuthenticated: false
};

const actionsHandlers = {
    [SET_AUTH]: (state, action) => {
        return {
            ...action.data,
            isAuthenticated: Object.keys(action.data).length ? true : false
        };
    },
    [SET_PROFILE]: (state, action) => {
        return {
            ...state,
            ...action.data
        };
    },
    [LOG_OUT]: (state, action) => {
        return {
            isAuthenticated: false
        };
    },
    [SET_PERMISSIONS]: (state, action) => {
        return {
            ...state,
            permissions: action.permissions,
            isSingleUser: action.isSingleUser,
            accountName: action.accountName,
        };
    }
};

const reducer = (state = initialState, action) => {
    const handler = actionsHandlers[action.type];
    return handler ? handler(state, action) : state;
};

export default reducer;
